import { Box, Text } from '@chakra-ui/react';
import ShizaiLogo from '../Shared/ShizaiLogo';

const ContactHeader = () => (
  <>
    <Box paddingTop="3.5rem">
      <Box width="100px" height="33px">
        <ShizaiLogo />
      </Box>
    </Box>
    <Box marginTop="2rem" />
    <Text as="h3" fontWeight={500} textStyle="h3">
      お問い合わせフォーム
    </Text>
  </>
);

export default ContactHeader;
